import { message } from "skin/event";
import { status } from "skin/event/status";

// Добавление ддопуска сотруднику сразу ко всем складам компании
const tnk_msAllowMany = (obj, ms, story, data, d, action) => {
	if (obj.action === "next") return check(data);
	return status.action;
};

export default tnk_msAllowMany;

// Проверяем что бы даты периода были указаны корректно, а так же была выбрана группа доступа
function check(data) {
	const _dict = data.curData.values.fld.txtG;
	const date1 = data.curData.values.fld.date1;
	const date2 = data.curData.values.fld.date2;

	if (!_dict) {
		message("Выберите группу доступа", "Ошибка заполнения полей");
		return status.ignore;
	}
	if (!date1 && !date2) {
		message("Укажите даты", "Ошибка заполнения полей");
		return status.ignore;
	}
	if (!date1 && date2) {
		message("Укажите с какого числа выдать доступ", "Ошибка заполнения полей");
		return status.ignore;
	}
	if (!!date1 && !!date2 && date1 > date2) {
		message("Дата начала не может быть больше даты окончания", "Ошибка заполнения полей");
		return status.ignore;
	}
	if (!!date1 && !!date2 && date1 === date2) {
		message("Даты не могут быть равны", "Ошибка заполнения полей");
		return status.ignore;
	}
	return status.action;
}
